module.exports = __webpack_public_path__ + "img/bank-asiento-disabled.38bf2048.svg";